/**
 * @file util files
 * @author liuyanan06
 * TODO: 这个目录的方法要尽可能复用工具库现有能力
 */
/* global yy */

import {getPlatInfo, compareSv, requestBdApi, openUrlByOpenApi, openBdMap} from '@baidu/map-fe-utils';

/**
 * 根据指定索引插入指定字符串
 * @param {string} originStr - 原始字符串
 * @param {number} index - 指定索引
 * @param {string} str - 指定字符
 * @returns 处理后的字符串
 */
export const insertStrByIndex = (originStr, index = 0, str = '') => {
    return originStr.slice(0, index) + str + originStr.slice(index);
};

/**
 * 根据指定索引集合插入指定字符串
 * @param {string} originStr - 原始字符串
 * @param {Array} indexes - 指定索引集合
 * @param {string} str - 指定字符
 * @returns 处理后的字符串
 */
export const insertStrByIndexes = (originStr, indexes = [], str = '') => {
    indexes.concat().sort((a, b) => b - a).forEach(index => {
        originStr = insertStrByIndex(originStr, index, str);
    });
    return originStr;
};

// 处理端内双 ？号 问题，只为了拿 stbar_height 因为getNativeInfo中的值不对，只能从 url上拿
export const getParams = function () {
    let urlParam = {};
    if (window.location.hash.indexOf('?') !== -1) {
        urlParam = parseUrlStringToObject(window.location.hash.split('?').pop());
    }
    let otherParams;

    if (window.location.href.indexOf('?') !== -1) {
        if (window.location.href.split('?').length > 2) {
            otherParams = parseUrlStringToObject(window.location.href.split('?')[1]);
        }
    }
    return Object.assign(urlParam, otherParams);
};

export const getParamsFromUrl = function () {
    if (window.location.hash.indexOf('?') !== -1) {
        return parseUrlStringToObject(window.location.hash.split('?').pop());
    }

    if (window.location.href.indexOf('?') !== -1) {
        return parseUrlStringToObject(window.location.href.split('?').pop().split('#')[0]);
    }
    return {};
};

function parseUrlStringToObject(str) {
    let obj = {};
    if (!str) {
        return {};
    }
    let arr = str.split('&');
    for (let index = 0; index < arr.length; index++) {
        let tmp = arr[index].split('=');
        if (tmp[1]) {
            // 判断a=&b=2的情况 去掉a
            obj[tmp[0]] = tmp[1];
        }
    }
    return obj;
}

export const plat = (() => {
    const ua = navigator.userAgent.toLowerCase();
    let res = {};
    res.isWeixin = ua.indexOf('micromessenger') > -1;
    res.isWeibo = ua.indexOf('weibo') > -1;
    const isNative
        = ua.indexOf('baidumap_andr') > -1 || ua.indexOf('baidumap_ipho') > -1 || ua.indexOf('baidumap_ipad') > -1;
    res.isNative = !res.isWeibo && !res.isWeixin && isNative;
    return res;
})();

export const makeIframeRequest = url => {
    const iframe = document.createElement('iframe');
    iframe.style.cssText = 'position:absolute;top:-9999px;left:-9999px;width:0;height:0';
    iframe.id = 'naaIframeRequest';
    iframe.setAttribute('src', url);
    document.body.appendChild(iframe);
    setTimeout(function () {
        document.body.removeChild(iframe);
    }, 100);
};

export const getNativeInfo = callback => {
    let time = new Date().getTime();
    let callbackName = 'naaInternalCallback' + time;
    let url = 'bdapi://getNativeInfo?callback=' + callbackName;

    if (window[callbackName]) {
        window[callbackName] = null;
    }
    else {
        window[callbackName] = function (res) {
            try {
                let result = JSON.parse(res);

                callback(result);
            }
            catch (e) {
                console.error(e);
            }
            window[callbackName] = null;
        };
    }
    makeIframeRequest(url);
};

export const fetchNAParams = () => {
    return new Promise(resolve => {
        let obj = getParamsFromUrl();
        if (plat.isNative) {
            // 地图壳环境下获取nativeInfo
            new Promise(resolve => {
                getNativeInfo(result => {
                    resolve(result);
                });
            }).then(result => {
                obj = Object.assign({}, result, obj);
                resolve(obj);
            });
        }
        else {
            resolve(obj);
        }
    });
};

export const initShare = shareInfos => {
    if (!plat.isNative || !shareInfos) {
        return;
    }
    const {title, content, imgUrl, curUrl} = shareInfos;
    const param = {
        shareList: [
            {
                shareTo: 'weixin',
                title: title,
                content: content,
                url: curUrl + '&from=weixin',
                contentType: 'text',
                imageSource: imgUrl
            },
            {
                shareTo: 'weixin_friend',
                title: title,
                content: content,
                url: curUrl + '&from=weixin',
                contentType: 'text',
                imageSource: imgUrl
            },
            {
                shareTo: 'sina_weibo',
                title: title,
                content: content,
                url: curUrl + '&from=weibo',
                contentType: 'text',
                imageSource: imgUrl
            }
        ]
    };
    const shareBDApiUrl = 'bdapi://setShareContent?' + window.encodeURIComponent(JSON.stringify(param));
    makeIframeRequest(shareBDApiUrl);
};


const openLayer = () => {
    // 页面已有浮层
    if (!document.getElementById('naa-share-fc')) {
        // 浮层dom和样式
        let div = document.createElement('div');
        div.style.cssText
            = 'background-color: rgba(0, 0, 0, 0.7); position: fixed; width: 100%;'
            + ' height:100%;top: 0; left: 0; bottom: 0;'
            + 'z-index: 9999999; overflow: hidden; transform: translateZ(999px);';
        div.id = 'naa-share-fc';
        let img = document.createElement('img');
        img.style.cssText = 'margin-left:19%;width:80%;';
        img.setAttribute('src', 'https://webmap0.bdimg.com/zt/y2016/welfareday/images/share_arrow_5179ee7.png');
        div.appendChild(img);
        document.body.appendChild(div);

        // 点击浮层隐藏
        document.getElementById('naa-share-fc').addEventListener(
            'click',
            function (e) {
                this.style.display = 'none';
            },
            false
        );
        // 出浮层时不能滚动
        document.getElementById('naa-share-fc').addEventListener(
            'touchmove',
            function (e) {
                e.preventDefault();
            },
            false
        );
    }
    else {
        document.getElementById('naa-share-fc').style.display = 'block';
    }
};

export const goToLogin = function (param = {}, gotoNativeCallback) {
    if (plat.isNative) {
        // 登录
        const sv = window.yymap.nativeAppAdapter.phoneinfo.sv || '0.0.0';
        if (window.yy.compareSv(sv, '10.10.0') === -1) {
            window.yymap.nativeAppAdapter.gotoLogin();
        }
        else {
            let bdapi = 'bdapi://login';
            let params = {
                login_page: 'normal',
                third_login_enable: '0',
                loginsourcetype: '登录',
                callback: 'signin' // 传callback不刷新页面，不传callback返回页面默认刷新页面
            };
            window.yymap.nativeAppAdapter.requestBdApi(bdapi, params);
        }
    }
    else {
        if (yy.naa.plat.isWeibo || yy.naa.plat.isWeixin) {
            openLayer();
        }
        else {
            const newUrl = location.href;
            const jumpUrl = 'baidumap://map/cost_share?transparentWeb=0&navigationStatus=2&popRoot=no&hiddenBackBtn=0&hiddenTitle=1&url='
                + encodeURIComponent(newUrl);
            window.location.href = jumpUrl;
            setTimeout(function () {
                window.location.href = 'https://map.baidu.com/zt/client/index/';
            }, 1000);
            gotoNativeCallback && gotoNativeCallback();
        }
    }
};


let historyCallBackQueen = [];
export const addHistory = callback => {
    // TODO: 去除端内限制，待验证
    // if (yy && yy.naa.plat.isNative) {
    // }

    const oncePopState = e => {
        const {page} = e.state || {};
        const index = page === undefined ? 0 : page + 1;
        if (historyCallBackQueen[index]) {
            const fn = historyCallBackQueen.pop();
            fn && fn();
            window.removeEventListener('popstate', oncePopState);
        }
    };

    if (window.history) {
        // pushState url参数不传时默认使用当前URL
        // 为当前页面添加历史时建议不干预url，ios可能会尝试加载新的url 而导致异常
        window.history.pushState({
            page: historyCallBackQueen.length
        }, null);

        historyCallBackQueen.push(callback);

        if (window.history.pushState) {
            window.addEventListener('popstate', oncePopState);
        }
    }
};

export const trimSpace = str => {
    return (str || '').replace(/(^\s+)|(\s+$)/g, '');
};
/**
 * 时间戳转化为日期格式
 * @param timestamp {string|number} 时间戳
 * @returns {string} 格式化后日期
 */
export const timestamp2Time = (timestamp, separator = '.') => {
    let result = '';
    let timestampStr = parseInt(timestamp, 10);
    if (timestampStr) {
        let date = new Date();
        date.setTime(timestampStr * 1000);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        if (separator) {
            result = year + separator + month + separator + day;
        }
        else {
            result = year + '年' + month + '月' + day + '日';
        }
    }
    return result;
};

/**
 * 判断当前环境是否支持webGL
 * @return {boolean} - 是否支持webGL
 */
export const isSupportWebGL = () => {
    const self = isSupportWebGL;
    if (typeof self._supportWebGL === 'boolean') {
        return self._supportWebGL;
    }
    if (!window.WebGLRenderingContext) {
        self._supportWebGL = false;
        return false;
    }

    // 检测创建gl环境是否成功
    let gl = null;
    const canvas = document.createElement('canvas');

    try {
        gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        if (gl && gl instanceof WebGLRenderingContext) {
            self._supportWebGL = true;
        }
    }
    catch (e) {
        self._supportWebGL = false;
    }
    if (gl === null) {
        self._supportWebGL = false;
    }

    return self._supportWebGL;
};

// 首句长度时num1,然后按照num分割
export const fixedLengthString =  (str, num1, num) => {
    if (str === null || str === undefined) {
        return null;
    }
    if (!(/^[0-9]*[1-9][0-9]*$/.test(num)) || !(/^[0-9]*[1-9][0-9]*$/.test(num1))) {
        return null;
    }

    let array = [];
    array.push(str.substring(0, num1));
    let restStr = str.substring(num1);
    let len = restStr.length;
    for (let i = 0; i < (len / num); i++) {
        if ((i + 1) * num > len) {
            array.push(restStr.substring(i * num, len));
        }
        else {
            let str2 = restStr.substring(i * num, (i + 1) * num);
            array.push(str2);
        }
    }
    return array;
};
// 将换行符换成空白字符
export const replaceLineBreak = str => {
    return str.replace(/\r\n|\n/g, '');
};
// 删除空白字符
export const trimAllSpace = str => {
    return str.replace(/\s+/g, '');
};
// 根据划分的句子,动态设置音频路径
export const setAudioSrc = str => {
    let sources = [];
    for (let i = 0; i < str.length; i++) {
        if (str[i]) {
            let audioUrl = location.protocol + '//tts.baidu.com/text2audio?tex=' + encodeURIComponent(str[i])
                + '&lan=zh&cuid=baidutts&pdt=511&key=com.baidu.tts.map-jingquyouwan.20180827&ctp=1&spd=5&aue=3';
            sources.push(audioUrl);
        }
    }
    return sources;
};

// 调基线协议，获取用户的全景个性化推荐开关状态
export const getUdcState = () => {
    const sv = getParamsFromUrl().sv || '0.0.0';
    return new Promise(resolve => {
        // 端内版本大于等于16.0.18，才请求端协议
        if (getPlatInfo().isNative && compareSv(sv, '16.0.18') >= 0) {
            const callbackFn = function (result) {
                resolve(Number(result));
            };
            const schemeUrl = 'bdapi://getUdcState?key=panorama_recommend';
            requestBdApi(schemeUrl, callbackFn);
        }
        else {
            resolve(null);
        }
    });
};

// 调基线协议，获取用户是否已经添加首页 icon
export const getIconState = type => {
    const sv = getParamsFromUrl().sv || '0.0.0';
    return new Promise(resolve => {
        // 端内版本大于等于16.1.0，才请求端协议
        if (getPlatInfo().isNative && compareSv(sv, '16.1.0') >= 0) {
            const callbackFn = function (result) {
                resolve(Number(result));
            };
            const schemeUrl = `bdapi://duhelperfunc?act=${type}&id=1112&name=${encodeURIComponent('3D实景')}`;
            requestBdApi(schemeUrl, callbackFn);
        }
        else {
            resolve(3);
        }
    });
};

/**
 * px-to-viewport
 * @param {number} pixels - 目标像素值
 * @param {Object} options - 配置项
 * @param {number} options.precision - 精度，保留小数点位数
 * @param {ueWidth} options.ueWidth - UE稿宽度
 */
export function px2vw(pixels, options = {
    precision: 5,
    ueWidth: 750
}) {
    return toFixed((pixels / options.ueWidth) * 100, options.precision) + 'vw';
}

export function toFixed(number, precision) {
    let multiplier = Math.pow(10, precision + 1);
    let wholeNumber = Math.floor(number * multiplier);
    return (Math.round(wholeNumber / 10) * 10) / multiplier;
}

export function openUrl(url, options = {
    hiddenNavigation: true
}) {
    if (!url) {
        return;
    }

    if (plat.isNative) {
        openUrlByOpenApi(url, options);
    }
    else {
        openBdMap({
            hiddenNavigation: true
        });
    }
}

export const isInTalos = () => {
    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
        return true;
    }
    return false;
};

export const formatNum = num => {
    if (num < 10000) {
        return num;
    }
    return (num / 10000).toFixed(1) + 'w';
};